import { Control, Controller } from "react-hook-form";
import YearSelect from "@/components/fields/YearSelect";
import { Field } from "@/components/ui/field";

interface BudgetYearControllerProps {
    control: Control<any, any>;
    name: string;
    label: string;
    readOnly: boolean;
    required?: boolean;
}

const BudgetYearController = ({ control, name, label, readOnly, required }: BudgetYearControllerProps) => {
    const mandatory = required ?? false;
    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: mandatory && "Fonds Jahr auswählen", validate: (value) => !mandatory || value > -1 || "Fonds Jahr auswählen" }}
            render={({ field: { value, onChange }, fieldState: { error, invalid } }) => (
                <Field id={name} label={label} required={mandatory} disabled={readOnly} invalid={invalid} errorText={error?.message}>
                    <YearSelect
                        isClearable={false}
                        value={value}
                        onChange={(year: number | null) => onChange(year)}
                    />
                </Field>
            )}
        />
    );
};

export default BudgetYearController;
